import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EmailBox from '../../../components/Enhanced/EmailBox';
import DoublePassword, { DoublePasswordValidation } from '../../../components/Sections/DoublePassword';
import SectionHeader from '../../../components/Basic/SectionHeader';
import CheckBox from '../../../components/Basic/CheckBox';
import FortisButton from '../../../components/Basic/FortisButton';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import LinkButton from '../../../components/Basic/LinkButton';
import PhoneContact, { PhoneContactValidator } from '../../../components/Sections/PhoneContact';
import BillingAddress, { BillingAddressValidation } from '../../../components/Sections/CustomerDetails/Common/BillingAddress';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';
import Switch from 'react-bootstrap-switch';


class Profile extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    props.resetUpdateEmailSuccess();
    props.resetSaveProfileSuccess();
    this.state = { userId: null, email: null, isBillingInit: false, isProjectsInit: false, isNotificationChanged: false };
  }
  componentWillReceiveProps(p) {

    if (p.user && !p.user.isAuthenticated) {
      browserHistory.push('/login');
      return;
    }
    if (p.updateEmailSuccess) {
      p.logOut();
      browserHistory.push('/logout');
      p.resetUpdateEmail();
      p.resetUpdateEmailSuccess();
    }

    if (p.user && !p.profileEmailAddress)
      p.resetProfileEmail(p.user.email);

    if (p.user && p.user.isSapLinked && !p.user.isSapError && !this.state.isBillingInit) {
      //console.log('init billing info');
      p.initBillingInfo(p.user);
      this.setState({ isBillingInit: true });
    }


    if (p.user && p.user.isAuthenticated && !this.state.isProjectsInit) {
      p.getProjects(p.user && p.user.bpNumber);
      this.setState({ isProjectsInit: true });
    }
  }

  onCancelClick = () => {
    browserHistory.push('/dashboard');
  };

  onChangePasswordClick = () => {
    const p = this.props;
    let validators = [
      ...DoublePasswordValidation('profilePassword')
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        UserId: p.user.id,
        Password: p.profilePassword,
        ConfirmPassword: p.profilePassword,
        Code: null
      };
      p.resetPassword(model);
    }
  };

  onUpdateEmailClick = () => {
    const p = this.props;
    let validators = [
      ['profileEmailAddress', p => p.profileEmailAddress, 'Profile email'],
      ['profileEmailAddress', p => !p.profileEmailAddress || util.isEmailValid(p.profileEmailAddress), '#Profile email is invalid'],
      ['agreeEmail', p => p.agreeEmail == 1, "#required"]
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        UserId: p.user.id,
        Email: p.profileEmailAddress
      };
      p.updateEmail(model);
    }
  };


  onSaveClick = () => {
    const p = this.props;
    let validators = [
      ['accountEmailAddress', p => p.accountEmailAddress, 'Account email'],
      ['accountEmailAddress', p => !p.accountEmailAddress || util.isEmailValid(p.accountEmailAddress), '#Account email is invalid'],
      ...PhoneContactValidator('accountPhoneContact'),
      ...BillingAddressValidation('accountBillingAddress', p.selectedAccountBillingAddress),
      ['agreeBillingInfo', p => p.agreeBillingInfo == 1, "#required"]
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        Id: p.user.id,
        UserName: p.user.username,
        Email: p.user.email,
        BPNumber: p.user.bpNumber,
        FirstName: p.user.firstName,
        LastName: p.user.lastName,
        CompanyName: p.user.companyName,
        IsContractor: p.user.isContractor,
        SAPEmail: p.accountEmailAddress,
        PrimaryPhone: p.primaryPhone,
        PrimaryPhoneExt: p.primaryPhoneExt,
        SecondaryPhone: p.secondaryPhone,
        SecondaryPhoneExt: p.secondaryPhoneExt,
        PrimaryCellPhone: p.primaryCellPhone,
        SecondaryCellPhone: p.secondaryCellPhone,
        MailingAddress: p.accountBillingAddress,
        IsSapLinked: p.user.isSapLinked,
        IsEmailNotificationAllowed: true,
        IsEmailNewsAllowed: true
      };
      p.saveProfile(model);
    }
  };

  checkNotification = () => {
    if (this.props.prjList == null || this.props.prjList == undefined) {
      return false;
    }
    else {
      const submittedProjects = this.props.prjList.filter(x => x.status.toLowerCase() === 'submitted');
      let count = 0;
      submittedProjects.map((item) => {
        if (item.isAllEmail) {
          count++;
        }
      });
      if (count > 0) {
        return true;
      }
    }
    return false;
  };

  switch = (e, s) => {
    const p = this.props;
    if (p.prjList && !s) {
      const modalLookup = window.osa && window.osa.commonLookup.modal; 
      const data = {
      headerText:  modalLookup.turnoffNotification.header,
      bodyText:  modalLookup.turnoffNotification.body,
      actionButtonText: "OK",
      closeButtonText: "Cancel",
      onActionClicked: () => {
          this.toggleNotifications(s);
        }
      };
      p.onShowModal(data);    
    }
    else {
        this.toggleNotifications(s);
    }
  };
  toggleNotifications = (s) => {
      const submittedProjects = this.props.prjList.filter(x => x.status.toLowerCase() === 'submitted');
      const projectsNumbers = submittedProjects.map(x => x.projectNo);
      this.props.toggleNotification(s, projectsNumbers);
      this.setState({ isNotificationChanged: true });
  };
  render() {
    const p = this.props;
    const lookup = window.osa && window.osa.commonLookup && window.osa.commonLookup.userProfile;
    const technicalError = window.osa && window.osa.commonLookup && window.osa.commonLookup.technicalError;
    const allNotificationEnable = this.checkNotification();

    return (
      <div>
        <div className="col-md-8 col-md-offset-2">
          <div className="panel-info-navigation">
            <div className="panel-info-navigation-body"><b>Important:</b> If you navigate away from this page (e.g. by clicking the back button in your browser), you will lose all of the information you have entered.</div>
          </div>
          <div className="text-danger" style={{ marginTop: '10px', marginBottom: '10px' }}>
            <span style={{ fontSize: '16px' }}>*</span>
            <span style={{ fontSize: '14px' }} >Required fields</span>

          </div>
          <div className="panel panel-primary">
            <div className="panel-heading"><h3 className="panel-title"><strong>My online profile</strong></h3></div>
            <div className="panel-body">
              {p.user && p.user.isSapLinked && !p.user.isSapError ?
                <div>
                  {p.user.isContractor ?
                    <div className="row" >
                      <div className="col-md-12">
                        <div className="form-group">
                          Company name:  <label> {p.user.companyName} </label>
                        </div>
                      </div>
                    </div>
                    :
                    <div className="row" >
                      <div className="col-md-12">
                        <div className="form-group">
                          Name:  <label> {p.user && p.user.firstName}  {p.user && p.user.lastName}</label>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                :
                null
              }
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    User ID:  <label>{p.user && p.user.username}</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12" >
                  <div className="form-group">
                    <SectionHeader title="Change password" />
                    <p> {lookup && lookup.passwordTip}</p>
                    <div className="row">
                      <div className="col-md-5">
                        <DoublePassword name="profilePassword" title1="Password" title2="Re-enter password" required />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12" >
                  <div className="form-group">
                    <ButtonToolbar  style={{display: "inline-flex"}}>
                      <FortisButton text="Change password" onClick={this.onChangePasswordClick} />
                      <LinkButton text="Cancel" onClick={this.onCancelClick} />
                    </ButtonToolbar>
                  </div>
                </div>
                {p.resetPasswordSuccess ?
                  <div className="col-md-12">
                    <b>Thank you! Your password has been updated.</b> You can <a onClick={this.onCancelClick}>continue reviewing the status of your service request(s).</a>
                  </div>
                  : null
                }
              </div>
              <div className="row">
                <div className="col-md-12" >
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-6">
                        <SectionHeader title="Change email" />
                      </div>
                      <div className="col-md-6">
                        <h5 style={{ textAlign: "left", fontWeight: "bold", marginTop: "0px", marginBottom: "0px" }}>All email notifications</h5>
                        <Switch bsSize="mini" value={allNotificationEnable} onChange={(e, s) => this.switch(e, s)} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <EmailBox name="profileEmailAddress" title="Profile email" required />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <CheckBox name="agreeEmail" title="<b>By updating my profile email, I am consenting to receive a verification email from FortisBC about my request.</b>" required />
                </div>
                <div className="col-sm-12" >
                  <p> Please ensure you click the link in the email to verify your email address.</p>
                  <div className="form-group">
                    <ButtonToolbar  style={{display: "inline-flex"}}>
                      <FortisButton text="Update profile email" onClick={this.onUpdateEmailClick} />
                      <LinkButton text="Cancel" onClick={this.onCancelClick} />
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            </div>

          </div>
          {
            p.user && p.user.isSapLinked && !p.user.isSapError ?

              <div className="panel panel-primary">
                <div className="panel-heading"><h3 className="panel-title"><strong>Billing information</strong></h3></div>
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-12" >
                      <div className="form-group">
                        <EmailBox name="accountEmailAddress" title="Account email" required />
                        <br />
                        {p.accountEmailAddress != p.profileEmailAddress ?
                          <p>Note that the email address associated to the account holder is different from the email address associated to the user profile</p>
                          : null
                        }
                      </div>
                    </div>
                    <div className="col-md-12">
                      <PhoneContact name="accountPhoneContact" isWideCol={true} />
                    </div>
                    <div className="col-md-12">
                      <BillingAddress name="accountBillingAddress" lookup={lookup.billingAddress} selectedBillingAddress={p.selectedAccountBillingAddress} />
                    </div>

                    <div className="col-sm-12">
                      <CheckBox name="agreeBillingInfo" title="<b>	I understand this will now be the new billing address for all of my accounts related to this profile and all future billing statements will be sent to this address.</b>" required />
                    </div>
                    <div className="col-sm-12" >
                      <div className="form-group">
                        <ButtonToolbar  style={{display: "inline-flex"}}>
                          <FortisButton text="Save profile" onClick={this.onSaveClick} />
                          <LinkButton text="Cancel" onClick={this.onCancelClick} />
                        </ButtonToolbar>
                      </div>
                    </div>
                    {
                      p.saveProfileSuccess ?
                        <div className="col-sm-12" >
                          <div className="form-group">
                            {
                              p.saveProfileSuccess == true ?
                                <div>
                                  <b>Thank you for updating your profile information.</b> Please note it may take up to 24 hours for the updates to appear. You can <a onClick={this.onCancelClick}>continue reviewing the status of your service request(s).</a>
                                </div>
                                :
                                <div className="control-label has-error">
                                  <span dangerouslySetInnerHTML={{ __html: technicalError }} /> You can <a onClick={this.onCancelClick}>continue reviewing the status of your service request(s).</a>
                                </div>
                            }
                          </div>
                        </div>
                        :
                        null
                    }
                  </div>
                </div>

              </div>
              : null
          }
        </div>
      </div>

    );
  }
}

Profile.propTypes = {
  user: PropTypes.object,
  profileEmailAddress: PropTypes.string,
  profilePassword: PropTypes.string,
  form: PropTypes.object,
  resetPasswordSuccess: PropTypes.bool,
  updateEmailSuccess: PropTypes.bool,
  saveProfileSuccess: PropTypes.bool,
  agreeEmail: PropTypes.int,
  agreeBillingInfo: PropTypes.int,
  primaryPhone: PropTypes.string,
  primaryPhoneExt: PropTypes.string,
  secondaryPhone: PropTypes.string,
  secondaryPhoneExt: PropTypes.string,
  primaryCellPhone: PropTypes.string,
  primaryCellPhoneExt: PropTypes.string,
  secondaryCellPhone: PropTypes.string,
  secondaryCellPhoneExt: PropTypes.string,
  accountEmailAddress: PropTypes.string,
  accountBillingAddress: PropTypes.object
};

function mapStateToProps(state) {
  return {
    form: state.form,
    prjList: state.gas.prjList,
    selectedAccountBillingAddress: state.form.accountBillingAddress,
    user: state.gas.user,
    profileEmailAddress: state.form.profileEmailAddress,
    agreeEmail: state.form.agreeEmail,
    agreeBillingInfo: state.form.agreeBillingInfo,
    profilePassword: state.form.profilePassword,
    resetPasswordSuccess: state.gas.resetPasswordSuccess,
    updateEmailSuccess: state.gas.updateEmailSuccess,
    saveProfileSuccess: state.gas.saveProfileSuccess,
    primaryPhone: state.form.accountPhoneContact_primaryPhone,
    primaryPhoneExt: state.form.accountPhoneContact_primaryPhone_ext,
    secondaryPhone: state.form.accountPhoneContact_secondaryPhone,
    secondaryPhoneExt: state.form.accountPhoneContact_secondaryPhone_ext,
    primaryCellPhone: state.form.accountPhoneContact_primaryCellPhone,
    primaryCellPhoneExt: state.form.accountPhoneContact_primaryCellPhone_ext,
    secondaryCellPhone: state.form.accountPhoneContact_secondaryCellPhone,
    secondaryCellPhoneExt: state.form.accountPhoneContact_secondaryCellPhone_ext,
    accountEmailAddress: state.form.accountEmailAddress,
    accountBillingAddress: {
      isPoBox: state.form.accountBillingAddress == "2",
      poBox: state.form.accountBillingAddress == "2" ? state.form.accountBillingAddress_poBox_poBox : state.form.accountBillingAddress_address_poBox,
      unitNumber: state.form.accountBillingAddress_address_unitNumber,
      streetNumber: state.form.accountBillingAddress_address_streetNumber,
      streetName: state.form.accountBillingAddress_address_streetName,
      streetType: state.form.accountBillingAddress_address_streetType,
      streetDirection: state.form.accountBillingAddress_address_streetDirection,
      city: state.form.accountBillingAddress == "2" ? state.form.accountBillingAddress_poBox_city : state.form.accountBillingAddress_address_city,
      province: state.form.accountBillingAddress == "2" ? state.form.accountBillingAddress_poBox_state : state.form.accountBillingAddress_address_province,
      postCode: state.form.accountBillingAddress == "2" ? state.form.accountBillingAddress_poBox_postalCode : state.form.accountBillingAddress_address_zip,
      country: state.form.accountBillingAddress == "2" ? state.form.accountBillingAddress_poBox_country : state.form.accountBillingAddress_address_country,
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initAPI: () => {
      dispatch({ type: 'INITIALIZE_PROFILE' });
      dispatch({ type: 'INITIALIZE_API' });
    },
    logOut: () => dispatch({ type: 'LOG_OUT' }),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    updateEmail: (model) => dispatch({ type: 'UPDATE_EMAIL', model }),
    saveProfile: (model) => dispatch({ type: 'SAVE_PROFILE', model }),
    resetUpdateEmailSuccess: () => dispatch({ type: 'UPDATE_EMAIL_SUCCESS', updateEmailSuccess: false }),
    resetSaveProfileSuccess: () => dispatch({ type: 'SAVE_PROFILE_SUCCESS', saveProfileSuccess: false }),
    resetUpdateEmail: () => dispatch({ type: 'RESET_UPDATE_EMAIL' }),
    resetPassword: (model) => dispatch({ type: 'RESET_PASSWORD', model }),
    initBillingInfo: (model) => dispatch({ type: 'INITIALIZE_STORE_BILLINGINFO', model }),
    resetProfileEmail: (model) => dispatch({ type: 'textbox', name: 'profileEmailAddress', value: model }),
    getProjects: (bp) => dispatch({ type: 'GET_PROJECT_LIST', bp: bp }),
    toggleNotification: (s, prjs) => dispatch({ type: 'DB_SWITCH', on: s, prjs: prjs }),
        onShowModal: (data) => dispatch({ type: 'SHOW_MODAL', data: data }),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Profile);

